import React from "react";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { serialize } from "next-mdx-remote/serialize";

import getTranslationByPath from "../services/getTranslationByPath.mjs";
import Hero from "../components/Features/Hero";
import WhatWeDo from "../components/Features/WhatWeDo";
import ExtraFeatures from "../components/Features/ExtraFeatures";
import RequestADemo from "../components/Common/RequestADemo";
import MetaTags from "../components/Common/MetaTags";

const Features = ({ features }) => {
  const theme = useTheme();
  const { t } = useTranslation(["features", "common"]);

  return (
    <>
      <MetaTags scope="features" />
      <Box
        bgcolor={theme.palette.alternate.main}
        position={"relative"}
        paddingBottom={5}
      >
        <Hero
          pageTitle={t("navbar.features", { ns: "common" })}
          title1={t("title1")}
          title2={t("title2")}
          title3={t("title3")}
          subtitle={t("subtitle")}
        />
        <Box
          component={"svg"}
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 1920 100.1"
          sx={{
            width: "100%",
            marginBottom: theme.spacing(-1),
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1,
            height: "10%",
            [theme.breakpoints.up("sm")]: {
              height: "30%",
            },
          }}
        >
          <path
            fill={theme.palette.background.paper}
            d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"
          ></path>
        </Box>
      </Box>
      <WhatWeDo features={features} />
      <ExtraFeatures />
      <RequestADemo title={t("cta.title")} />
    </>
  );
};

export default Features;

export async function getStaticProps({ locale }) {
  const {
    content: {
      features_list: { features },
    },
  } = getTranslationByPath("features", locale);

  features.map(async (feature) => {
    feature.content = await serialize(feature.content);
  });

  return {
    props: {
      ...(await serverSideTranslations(locale, ["common", "features"])),
      features,
    },
  };
}
